<ul>
  @for (option of group().options; track option) {
  <li [ngClass]="{ selected: option.active }">
    <a
      (click)="optionChange(group().id, option.value)"
      (keydown.enter)="optionChange(group().id, option.value)"
      [title]="option.label"
      tabindex="0"
    >
      @if (group().attributeType === 'colorCode') {
      <span
        [ngStyle]="{ 'background-color': '#' + option.metaData }"
        [ngClass]="{ 'light-color': option.label.toLowerCase() === 'white' }"
      ></span>
      } @if (group().attributeType === 'swatchImage') {
      <img [src]="option.metaData" alt="{{ option.label }}" />
      }
    </a>
  </li>
  }
</ul>
